import { FormType, FormTypeProps } from './FormType';
import { ToTypeTransformer, ToPlainTransformer } from '../transformers';

export class EntityFormType<T extends object, TEntity extends object = T> extends FormType<T, TEntity> {
    constructor(protected TCreator: new () => TEntity | TEntity) {
        super();
    }

    buildForm(data: T): FormTypeProps<T> {
        const initialValues = new ToPlainTransformer().transform(data);
        return super.buildForm(initialValues);
    }

    getEntity(value: T): TEntity {
        return new ToTypeTransformer(this.TCreator).transform(value);
    }
}
